import * as LJS from "../../lib/littlejs.esm";
import Globals from '../globals.ts';
import Object from "./object.ts";
class Enemy extends Object {
    constructor(pos, world) {
        super(pos, 360, world);
        this.fallDelay = 120;
        this.fallTimer = 0;
        this.isGoingToFall = false;
        this.isFalling = false;
        this.minX = 0;
        this.maxX = 0;
        this.movingRight = true;
        this.speed = 0.02;
        this.defaultMass = 1;
        // When we instanciate the enemy, we put a limit on how far
        // he can go on the left and right
        // @TODO - Clamp to the level width
        this.minX = pos.x - 4;
        this.maxX = pos.x + 4;
        // In order to not have him fall of edges, we check if the
        // ground / platforms below him are going far enough
        for (let i = this.minX; i < this.maxX; i++) {
            // Check if there is a tile (wall/obstacle) at this position
            const tileAtPosition = LJS.tileCollisionTest(LJS.vec2(i, this.pos.y), LJS.vec2(1, 1));
            let hasObstacle = !!tileAtPosition;
            // Check if there is a tile under this position
            const tileUnderPosition = LJS.tileCollisionTest(LJS.vec2(i, this.pos.y - 1), LJS.vec2(1, 1));
            let hasGround = !!tileUnderPosition;
            // If there was no tile detected, we check that
            // there is no solid entity (platform, spikes) at the level
            // of the enemy, or there is a walkable entity (platform)
            // under the position
            if (!hasGround || !hasObstacle) {
                for (const obj of LJS.engineObjects) {
                    if (obj instanceof Object && obj.walkable && LJS.isOverlapping(LJS.vec2(i, this.pos.y - 1), LJS.vec2(1, 1), obj.pos, obj.size) && (obj.world == this.world || !obj.world || !this.world)) {
                        hasGround = true;
                    }
                    if (obj instanceof Object && obj.solid && LJS.isOverlapping(LJS.vec2(i, this.pos.y), LJS.vec2(1, 1), obj.pos, obj.size) && (obj.world == this.world || !obj.world || !this.world)) {
                        hasObstacle = true;
                    }
                }
            }
            // If we can not walk here, we update the minX and maxX
            if (!hasGround || hasObstacle) {
                if (i < this.pos.x) {
                    this.minX = i + 1;
                }
                else if (i > this.pos.x) {
                    this.maxX = i - 1 > this.maxX ? this.maxX : i - 1;
                }
            }
        }
    }
    update() {
        super.update();
        if (!this.disabled) {
            // Check for overlap with player
            if (Globals.player && LJS.isOverlapping(this.pos, this.size, Globals.player.pos, Globals.player.size)) {
                Globals.player.takeDamage(1, true);
            }
        }
        // Move the enemy from left to right automatically
        if (this.movingRight && this.pos.x >= this.maxX) {
            this.movingRight = false;
        }
        else if (!this.movingRight && this.pos.x <= this.minX) {
            this.movingRight = true;
        }
        this.pos.x += this.speed * (this.movingRight ? 1 : -1);
    }
    defaultCollision() {
        this.setCollision(true, false, true, false);
    }
}
export default Enemy;
